import { ID } from '..';
import { ColumnOptions } from '../../interfaces/options/column';
import { DefaultEditCommandOptions } from './editCommand';
import { DefaultDeleteCommandOptions } from './deleteCommand';
import { DefaultBaseTableCommandColumnOptions } from './baseTableCommandColumn';

export function DefaultTableCommandColumnOptions<T>(): ColumnOptions<T> {
	return <ColumnOptions<T>>$.extend(true, {}, DefaultBaseTableCommandColumnOptions<T>(), <
		ColumnOptions<T>
	>{
		key: ID.Commands,
		commands: [DefaultEditCommandOptions<T>(), DefaultDeleteCommandOptions<T>()]
	});
}
